export function getQpjlClient () {
    const userAgent = typeof navigator !== 'undefined' ? String(navigator.userAgent || '').toLowerCase() : ''
    if (userAgent.indexOf('miniprogram') !== -1) return 'mp-weixin'
    if (userAgent.indexOf('micromessenger') !== -1) return 'wechat-mp'
    if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) return 'h5'
    return 'pc'
}
